import React, { useEffect, useState } from "react";
import { getUserLeadSummary } from "../../services/leads";
import { errorMessage } from "../../utils/alertMessage";
import { getUser } from "../../services/userMasterUser";
import { MultiSelect } from "primereact/multiselect";

const RetailPipeline = () => {

  const [activeView, setActiveView] = useState("loan");

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 3); // subtract 7 days to current date

  const [startDate, setStartDate] = useState(new Date(localStorage.getItem("startDateFilter")));
  const [endDate, setEndDate] = useState(new Date(localStorage.getItem("endDateFilter")));

  const [leadData, setLeadData] = useState([])
  const [userDataFilter, setUserDataFilter] = useState("");
  const [userDataId, setUserDataId] = useState([]);
  const [userDataIds, setUserDataIds] = useState([]);
  const [leadTotalCountData, setLeadTotalCountData] = useState(0);
  const [leadTotalAmountData, setLeadTotalAmountData] = useState(0);

  useEffect(() => {
    const userData = {
      searchBy: "",
      searchText: "",
      limit: 1000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      userTypeIdIn: [],
      roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
      statusIn: ["ACTIVE"]

    };

    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const newDataId = newData.map(item => item.id);
          const newDataIds = newData.map(item => ({
            label: item.userName + " - " + item?.userTypeInfo, value: item.id
          }));

          setUserDataIds(newDataIds)
          setUserDataId(newDataId)

          handleActiveTab("loan", {
            ...typeLoanData,
            userIdIn: newDataId
          })
        }
      })
      .catch(() => {
        errorMessage();
      })

  }, [])

  const typeLoanData = {
    leadTypeIn: [
      "Loan",
      "loan_type_lead",
    ],
    recordType: "CreatedOn",
    startDate: startDate,
    endDate: endDate,
    userIdIn: userDataFilter ? userDataFilter : userDataId,
    minAmount: 10000000,
    maxAmount: 0
  };

  const typeProjectReportData = {
    leadTypeIn: [
      "Project report - Leads",
      "project_report_tev_study_pitch_deck",
    ],
    recordType: "CreatedOn",
    startDate: startDate,
    endDate: endDate,
    userIdIn: userDataFilter ? userDataFilter : userDataId,
    minAmount: 10000000,
    maxAmount: 0
  };

  const fetchData = (data) => {

    getUserLeadSummary(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;
          const totalCount = rawData.reduce((sum, item) => sum + (item?.count || 0), 0);
          const totalAmount = rawData.reduce((sum, item) => sum + (item?.totalAmount || 0), 0);
          setLeadData(rawData);
          setLeadTotalCountData(totalCount);
          setLeadTotalAmountData(totalAmount);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
      });
  };

  const handleActiveTab = (type, loanType) => {
    setActiveView(type)
    fetchData(loanType)
  }

  useEffect(() => {


    const hasValidFilter =
      userDataFilter;

    if (!hasValidFilter) return;

    if (activeView === "loan") {
      fetchData({
        ...typeLoanData,
        userIdIn: userDataFilter ? userDataFilter : []
      });
    } else {
      fetchData({
        ...typeProjectReportData,
        userIdIn: userDataFilter ? userDataFilter : []
      });
    }


  }, [userDataFilter]);

  function formatIndianShort(value) {
    if (value == null || isNaN(value)) return "";

    const num = Number(value);

    if (num >= 10000000) {
      return (num / 10000000).toFixed(num % 10000000 === 0 ? 0 : 1) + "Cr";
    }

    if (num >= 100000) {
      return (num / 100000).toFixed(num % 100000 === 0 ? 0 : 1) + "L";
    }

    return num.toLocaleString("en-IN");
  }

  const OrderStatusColors = [
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#3EB3E1",
    "#866CCE",
    "#F5C43A",
    "#09B4AA",
    "#55BD5A",
    "#FF6767",
    "#5D53D8",
    "#6EA4F5",
    "#E89534",
    "#a906c2",
    "#000",
  ];

  return (
    <main id="main" className="main">
      <section className="section dashboard">
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12">
            <div className="row">
              {/* Sales Card */}
              <div className=" col-md-12">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <div class="sec-hdr">
                      <div class="sec-ico">
                        📥
                      </div>
                      <div>
                        <div class="sec-title">Lead Status — Lead Box</div>
                        <div class="sec-sub">No. of leads · Total loan amounts</div>
                      </div>
                    </div>
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px", marginBottom: 10 }}>
                        <button
                          className={`btn ${activeView === "loan" ? "btn-primary" : "btn-light"}`}
                          onClick={() => handleActiveTab("loan", typeLoanData)}
                        >
                          Loans
                        </button>

                        <button
                          className={`btn ${activeView === "project" ? "btn-primary" : "btn-light"}`}
                          onClick={() => handleActiveTab("project", typeProjectReportData)}
                        >
                          Project Report
                        </button>
                      </div>

                      <div className="row">
                        <div className="col-md mb-2">
                          <MultiSelect
                            style={{ width: "100%" }}
                            value={userDataFilter}
                            onChange={(e) => setUserDataFilter(e.value)}
                            options={userDataIds}
                            optionLabel="label"
                            placeholder="Select User"
                          />
                        </div>
                      </div>
                    </div>


                    {activeView === "loan" && (
                      <>
                        {/* Loan KPI Row */}
                        <div className="kpi-row">
                          <div className="kpi" style={{ borderLeftColor: "#E87010" }}>
                            <div className="kpi-lbl">Total Leads</div>
                            <div className="kpi-val">{leadTotalCountData}</div>
                          </div>
                          <div className="kpi" style={{ borderLeftColor: "#16A869" }}>
                            <div className="kpi-lbl">Total Amount</div>
                            <div className="kpi-val">₹{formatIndianShort(leadTotalAmountData)}</div>
                          </div>


                        </div>

                        <div
                          className="kpi-row-forth"
                          style={{
                            marginTop: 10,
                            marginBottom: 10,
                          }}
                        >
                          {leadData.map((item, index) => (
                            <div
                              key={item.status}
                              className="kpi"
                              style={{
                                borderLeftColor:
                                  OrderStatusColors[index % OrderStatusColors.length],
                              }}
                            >
                              <div className="kpi-lbl">
                                {item.leadStatus === "hold for follow up after sometime" ? "hold for follow" : item.leadStatus} - <span style={{ fontSize: 14, color: "#3b6eef" }}> {item.count}</span>
                              </div>

                              <div className="kpi-val">
                                ₹{formatIndianShort(item.totalAmount)}
                              </div>
                            </div>
                          ))}
                        </div>

                      </>
                    )}

                    {activeView === "project" && (
                      <>
                        {/* Project KPI Row */}
                        <div className="kpi-row">
                          <div className="kpi" style={{ borderLeftColor: "#E87010" }}>
                            <div className="kpi-lbl">Total Leads</div>
                            <div className="kpi-val">{leadTotalCountData}</div>
                          </div>
                          <div className="kpi" style={{ borderLeftColor: "#16A869" }}>
                            <div className="kpi-lbl">Total Amount</div>
                            <div className="kpi-val">₹{formatIndianShort(leadTotalAmountData)}</div>
                          </div>


                        </div>

                        <div
                          className="kpi-row-forth"
                          style={{
                            marginTop: 10,
                            marginBottom: 10,
                          }}
                        >
                          {leadData.map((item, index) => (
                            <div
                              key={item.status}
                              className="kpi"
                              style={{
                                borderLeftColor:
                                  OrderStatusColors[index % OrderStatusColors.length],
                              }}
                            >
                              <div className="kpi-lbl">
                                {item.leadStatus === "hold for follow up after sometime" ? "hold for follow" : item.leadStatus} - <span style={{ fontSize: 14, color: "#3b6eef" }}> {item.count}</span>
                              </div>

                              <div className="kpi-val">
                                ₹{formatIndianShort(item.totalAmount)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default RetailPipeline;
